import { render } from "./AIDTP3.vue?vue&type=template&id=0298be76&scoped=true"
import script from "./AIDTP3.vue?vue&type=script&lang=js"
export * from "./AIDTP3.vue?vue&type=script&lang=js"

import "./AIDTP3.vue?vue&type=style&index=0&id=0298be76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0298be76"]])

export default __exports__